import { EnergyConsumption } from "./EnergyConsumption";
import { ExternalBookingRoom } from "./ExternalBookingRoom";
import { HousekeepingSchedule } from "./HousekeepingSchedule";
import { HousekeepingTask } from "./HousekeepingTask";
import { IoTRoomControl } from "./IoTRoomControl";
import { KeycardRoom } from "./KeycardRoom";
import { RateComparison } from "./RateComparison";
import { ReservationRoom } from "./ReservationRoom";
import { RoomAssignment } from "./RoomAssignment";
import { RoomAvailability } from "./RoomAvailability";
import { RoomAvailabilitySync } from "./RoomAvailabilitySync";
import { RoomPricing } from "./RoomPricing";
import { RoomType } from "./RoomTypes";

export interface Room {
    roomId: number;
    roomNumber: string;
    roomType: RoomType[];  // Changed to an array of strings
    roomCategory: string;
    status: string;
    rate: any;
    description: string;
    maxOccupancy: any;
    amenities: string;
    dateAdded: string; // Assuming this is an ISO 8601 string
    updatedAt: string; // Assuming this is an ISO 8601 string
    roomName: string;
    imageurl: string;
    floorNumber: any;
    roomview: string;
    isSmokingAllowed: boolean;
    bedType: string;
    roomDimensions: string;
    accessibilityFeatures: string;
    roomPolicies: string;
    airecommendationPredictedRooms: string[]; // Array of strings, likely IDs
    airecommendationRecommendedRooms: string[]; // Array of strings, likely IDs
    energyConsumptions: EnergyConsumption[];
    externalBookings: ExternalBookingRoom[];
    housekeepingSchedules: HousekeepingSchedule[];
    housekeepingTasks: HousekeepingTask[];
    ioTroomControls: IoTRoomControl[];
    keycards: KeycardRoom[];
    rateComparisons: RateComparison[];
    reservations: ReservationRoom[];
    roomAssignments: RoomAssignment[];
    roomAvailabilities: RoomAvailability[];
    roomAvailabilitySyncs: RoomAvailabilitySync[];
    roomPricings: RoomPricing[];
  }




  export const InitRoom: Room = {
    roomId: 0,
    roomNumber: "",
    roomType: [],
    roomCategory: "",
    status: "",
    rate: "",
    description: "",
    maxOccupancy: "",
    amenities: "",
    dateAdded: "",
    updatedAt: "",
    roomName: "",
    imageurl: "",
    floorNumber: "",
    roomview: "",
    isSmokingAllowed: false,
    bedType: "",
    roomDimensions: "",
    accessibilityFeatures: "",
    roomPolicies: "",
    airecommendationPredictedRooms: [],
    airecommendationRecommendedRooms: [],
    energyConsumptions: [],
    externalBookings: [],
    housekeepingSchedules: [],
    housekeepingTasks: [],
    ioTroomControls: [],
    keycards: [],
    rateComparisons: [],
    reservations: [],
    roomAssignments: [],
    roomAvailabilities: [],
    roomAvailabilitySyncs: [],
    roomPricings: []
  };
  